import { JsonObject } from 'json2typescript';
import { EvalGoalInterface } from '../interfaces/eval-goal.interface';

@JsonObject('EvalGoalModel')
export class EvalGoalModel implements EvalGoalInterface {
  goal?: Goal;
  hints?: Hint[];
  initial_investment?: InitialInvestment[];
  model_portfolio_id?: number;
  planning?: Planning[];
  risk_profile?: RiskProfile;
  model_portfolio_code?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Goal')
export class Goal {
  achieved_goal?: number;
  achieved_living_standards?: number;
  achievement_commentary?: string;
  achievement_full_commentary?: string;
  bestpath_achieved_goal?: number;
  bestpath_achieved_living_standards?: number;
  bestpath_periodic_contribution?: number;
  currency?: string;
  estimatedpath_periodic_contribution?: number;
  goal_amount?: number;
  goal_month?: number;
  goal_status?: string;
  goal_summary_commentary?: string;
  goal_year?: number;
  investment_horizon?: number;
  is_goal_achieved?: boolean;
  worstpath_achieved_goal?: number;
  worstpath_achieved_living_standards?: number;
  worstpath_periodic_contribution?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Hint')
export class Hint {
  commentary?: string;
  type?: string;
  value?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('InitialInvestment')
export class InitialInvestment {
  amount?: number;
  asset_class_id?: number;
  asset_class_name?: string;
  currency?: string;
  product_code?: string;
  product_name?: string;
  weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Planning')
export class Planning {
  acum_contribution?: number;
  best_path?: number;
  estimated_path?: number;
  goal?: number;
  month?: number;
  worst_path?: number;
  year?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('RiskProfile')
export class RiskProfile {
  annual_negaitive_performance?: number;
  annual_positive_performance?: number;
  id?: number;
  model_portfolio_id?: number;
  model_portfolio_name?: string;
  name?: string;
  original_client_riskprofile_id?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
